import React from "react";
import { Stack, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Link from "@mui/material/Link";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import "./ConfirmationModal.css";

const URL_PATTERN = /(https?:\/\/[^\s<>"']+)/g;

// Turns bare http(s) URLs in plain text into links; trailing punctuation stays outside the link.
const linkifyText = (text) =>
  String(text)
    .split(URL_PATTERN)
    .map((part, index) => {
      if (index % 2 === 0) return part;
      const [, url, trailing] = part.match(/^(.*?)([.,;:!?)]*)$/);
      return (
        <React.Fragment key={index}>
          <Link href={url} target="_blank" rel="noopener noreferrer">
            {url}
          </Link>
          {trailing}
        </React.Fragment>
      );
    });

const ConfirmationModal = (props) => {
  const orgDisplayName = props.params?.orgDisplayName || props.params?.organization || "";
  const memberFirmOptions = [
    "Deloitte Africa",
    "Deloitte Asia Pacific",
    "Deloitte Australia",
    "Deloitte Austria",
    "Deloitte Belgium",
    "Deloitte Brazil",
    "Deloitte Canada",
    "Deloitte Caribbean and Bermuda Countries",
    "Deloitte Central Europe",
    "Deloitte Central Mediterranean",
    "Deloitte Chile",
    "Deloitte China",
    "Deloitte Cyprus",
    "Deloitte Denmark",
    "Deloitte DKU",
    "Deloitte Finland",
    "Deloitte France",
    "Deloitte Germany",
    "Deloitte Iceland",
    "Deloitte Ireland",
    "Deloitte Israel",
    "Deloitte Japan",
    "Deloitte Korea",
    "Deloitte Luxembourg",
    "Deloitte Mauritius",
    "Deloitte Mexico",
    "Deloitte Middle East",
    "Deloitte Netherlands",
    "Deloitte New Zealand",
    "Deloitte Nordics",
    "Deloitte North and South Europe",
    "Deloitte Norway",
    "Deloitte Portugal",
    "Deloitte S-LATAM",
    "Deloitte South Asia(India)",
    "Deloitte Southeast Asia",
    "Deloitte Spain",
    "Deloitte Sweden",
    "Deloitte Taiwan",
    "Deloitte Touche Tohmatsu Limited",
    "Deloitte Turkey",
    "Deloitte United Kingdom",
    "Deloitte United States",
  ];
  return (
    <div>
      <Dialog
        open={props.show}
        onClose={props.close}
        sx={{
          backdropFilter: "blur(1px)",
          //other styles here
        }}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        {/* Dialog Title */}
        <DialogTitle id="scroll-dialog-title" sx={{ background: "white" }}>
          Confirm Request
        </DialogTitle>
        <DialogContent
          sx={{
            maxHeight: "calc(100% - 209px)",
            maxWidth: "38vw",
            letterSpacing: "0.00938em",
            color: "black",
          }}
        >
          <div>
            {props.params?.approvalRequired === "Yes"
              ? "Are you sure you want to request access to "
              : "Are you sure you want to join "}
            <strong role="orgName">{`${props.params.orgDisplayName}?`}</strong>
          </div>
          {props.params?.signup_banner && (
            <div className="org-description">
              <p>{linkifyText(props.params.signup_banner)}</p>
            </div>
          )}
          {props.params?.approvalRequired === "Yes" && props.isDTGlobalCollab ? (
            <div style={{ marginTop: "20px", marginBottom: "20px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", marginBottom: "5px" }}
                >
                  Project Need <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  value={props.dtProjectNeed}
                  placeholder="Enter Project Need"
                  onChange={(event) =>
                    props.setDtProjectNeed(event.target.value || "")
                  }
                />

                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", marginBottom: "5px" }}
                >
                  Member Firm Details <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  select
                  value={props.dtMemberFirmDetails}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        sx: {
                          maxHeight: 280,
                        },
                      },
                    },
                  }}
                  onChange={(event) =>
                    props.setDtMemberFirmDetails(event.target.value || "")
                  }
                >
                  <MenuItem value="">Select Member Firm</MenuItem>
                  {memberFirmOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", marginBottom: "5px" }}
                >
                  Project Lead <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  value={props.dtProjectLead}
                  placeholder="Enter Project Lead"
                  onChange={(event) =>
                    props.setDtProjectLead(event.target.value || "")
                  }
                />
              </div>
            </div>
          ) : props.params?.approvalRequired === "Yes" ? (
            <div style={{ marginTop: "20px", marginBottom: "20px" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", marginBottom: "5px" }}
                >
                  Reason for Requesting Access{" "}
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  labelid="demo-simple-select-label"
                  id="demo-simple-select"
                  multiline
                  rows={4}
                  placeholder="Please enter your request reason (minimum 40 characters)"
                  value={props.requestReason}
                  helperText={
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        fontSize: "11px",
                      }}
                    >
                      <span>Minimum 40 characters</span>
                      <span>{props.requestReason.length} characters</span>
                    </span>
                  }
                  onChange={(event) =>
                    props.setRequestReason(event.target.value)
                  }
                />
              </div>
            </div>
          ) : null}
          <p>
            {props.params?.approvalRequired === "Yes" ? (
              <>
                <strong>Note: </strong>Processing time may take up to 3 hours
                after an organization owner approves your request
              </>
            ) : (
              <>
                <strong>Note: </strong>Processing time for requests may take up
                to 3 hours
              </>

            )}
          </p>
          <p>
            Click <a
              href={`/global-orgs?search=${orgDisplayName.replace(/\s+/g, '-')}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer" }}
            >
              here
            </a> to view this organization details, including owners and approvers.
          </p>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Stack
            sx={{
              padding: "0.2rem 0rem",
              margin: "0 auto",
              alignContent: "center",
              justifyContent: "center",
            }}
            direction="row"
            spacing={5}
          >
            <Button
              sx={{
                backgroundColor: "white",
                border: "1px solid gray",
                letterSpacing: "0.5px",
                padding: "4px 16px",
                borderRadius: "3px",
                fontSize: "14px",
                color: "black",
              }}
              onClick={props.close}
            >
              Cancel{" "}
            </Button>
            <Button
              role="requestAccessBtn"
              sx={{
                backgroundColor: "#86BC25",
                letterSpacing: "0.5px",
                padding: "4px 16px",
                borderRadius: "3px",
                fontSize: "14px",
                color: "white",
                "&:hover": {
                  backgroundColor: "#86BC25",
                  color: "white",
                },
                "&:disabled": {
                  textTransform: "uppercase",
                },
                minWidth: "8vw",
              }}
              onClick={props.onAddOrganizationHandler}
              disabled={
                props.params?.approvalRequired === "Yes" && props.isDTGlobalCollab
                  ? !props.dtProjectNeed ||
                    !props.dtMemberFirmDetails ||
                    !props.dtProjectLead
                  : props.params?.approvalRequired === "Yes" &&
                    (props.requestReason === "" || props.requestReason.length < 40)
                    ? true
                    : false
              }
            >
              {props.params?.approvalRequired === "Yes"
                ? "Request Access"
                : "Join"}
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmationModal;
